import React from 'react';
import classNames from 'classnames';
import { withRouter } from 'react-router';

class Cursor extends React.Component{
  constructor(props){
    super(props);

    this.state = {
      left: false,
      top: false,
      hovered: false,
      links: false
    }
  }
  componentDidUpdate = prevProps => {
    if(prevProps.location.key !== this.props.location.key){
      this._prepareLinks();
    }
  }
  componentDidMount(){
    this._prepareLinks();
  }
  _prepareLinks(){
    const links = document.querySelectorAll('a, .a');

    this.setState({links}, () => {
      this._addEventListeners();
    });
  }
  _addEventListeners(){
    window.addEventListener('mousemove', this._handleMouseMove);

    [...this.state.links].map(link => {
      link.addEventListener('mouseover', this._handleMouseOver);
      link.addEventListener('mouseleave', this._handleMouseLeave);
    });

    document.body.classList.add('no-cursor');
  }
  componentWillUnmount(){
    window.removeEventListener('mousemove', this._handleMouseMove);

    [...this.state.links].map(link => {
      link.removeEventListener('mouseover', this._handleMouseOver);
      link.removeEventListener('mouseleave', this._handleMouseLeave);
    });
  }
  _handleMouseOver = e => this.setState({hovered: true});
  _handleMouseLeave = e => this.setState({hovered: false});

  _handleMouseMove = e => {
    this.setState({
      top: e.clientY,
      left: e.clientX,
    })
  }

  render(){
    return <div className={classNames('cursor', {
        'cursor--hovered': this.state.hovered
      })} style={{left: this.state.left, top: this.state.top}}>
        {this.props.children}
      </div>
  }
}

export default withRouter(Cursor);
